// src/api/profileApi.js
import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getPosUserSocialLinks = async () => {
  try {
    const lang = localStorage.getItem("lang") || "en";
    const token = localStorage.getItem("token");

    // ✅ If api already has baseURL, use relative path
    const res = await api.get(`${API_BASE_URL}api/users/profile`, {
      headers: {
        "Accept-Language": lang,
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    });

    // ✅ backend returns profile object directly
    const profile = res.data || {};

    return {
      success: true,
      data: profile.socialLinks || {},
      profile,
    };
  } catch (error) {
    console.error("getPosUserSocialLinks Error:", error?.response?.data || error);
    return {
      success: false,
      error: error?.response?.data?.message || error.message || "Failed",
    };
  }
};